<form nz-form [formGroup]="formGroup" (ngSubmit)="submit()">
  <div class="page-content-section">
    <fieldset>
      <legend>{{'Information' | translate}}</legend>
      <nz-form-item *ngIf="mode === 'edit'">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Code">
          {{'Id' | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="Please insert the id.">
          <input nz-input formControlName="Id" id="Id" readonly />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Name">
          {{'Name' | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please insert the name.'">
          <input nz-input formControlName="Name" id="Name" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Name">
          {{'Is Default' | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please select if this is the default.' | translate">
          <nz-select [nzAllowClear]="true" formControlName="IsDefault">
            <nz-option [nzValue]="true" [nzLabel]="'Yes' | translate"></nz-option>
            <nz-option [nzValue]="false" [nzLabel]="'No'| translate"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Name">
          {{'Roles can edit products' | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please select a role.' | translate">
          <nz-select formControlName="RolesToEditProduct" nzMode="tags" [nzTokenSeparators]="[',']"
            nzPlaceHolder="automatic tokenization">
            <nz-option *ngFor="let option of rolesOptions" [nzLabel]="option.name" [nzValue]="option.id"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </fieldset>
  </div>
  <input type="submit" style="display: none" />
</form>
